module.exports = __webpack_public_path__ + "static/media/expatriate_content_Icons_new.4fb521c5.png";